// Store avatar statuses by avatarId for polling simulation
export const avatarStatusStore = new Map<
  string,
  {
    __typename:
      | 'ProfileAvatarStatusPending'
      | 'ProfileAvatarStatusSuccess'
      | 'ProfileAvatarStatusFailure';
    error?: {
      __typename: string;
      title: string;
      message: string;
    };
  }
>();

export const getProfileAvatarStatus = (
  _: unknown,
  { avatarId }: { avatarId: string },
) => {
  // If status exists in store, return it
  const storedStatus = avatarStatusStore.get(avatarId);
  if (storedStatus) {
    return storedStatus;
  }

  // Default to pending for new avatar uploads
  // In a real scenario, this would transition to success after some time
  const status = {
    __typename: 'ProfileAvatarStatusPending' as const,
  };
  avatarStatusStore.set(avatarId, status);
  return status;
};
